import React from "react";
import { Button } from "react-bootstrap";

/**
 * Catches render errors inside the route tree so production never shows a blank screen.
 */
export default class RoutingErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[RoutingErrorBoundary]", error, info?.componentStack);
  }

  handleRetry = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    if (this.state.error) {
      return (
        <div
          className="d-flex flex-column justify-content-center align-items-center min-vh-100 px-3"
          style={{ background: "#f8f9fa" }}
        >
          <div
            className="bg-white shadow-sm rounded p-4 p-md-5 text-center"
            style={{ maxWidth: "28rem" }}
          >
            <h1 className="h5 mb-3">Κάτι πήγε στραβά</h1>
            <p className="text-muted small mb-4">
              Παρουσιάστηκε σφάλμα κατά τη φόρτωση της σελίδας. Ανανεώστε ή επιστρέψτε στην
              αρχική.
            </p>
            <Button variant="primary" onClick={this.handleRetry}>
              Ανανέωση σελίδας
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
